import { IParamsByUrl } from '~types/search'

const changePage = ({
  urlParams,
  page,
}: {
  urlParams: IParamsByUrl
  page?: number
}) => {
  const params = {
    ...urlParams,
    currentPage: page || 1,
  }

  return params
}

export default changePage
